<template>
  <b-modal ref="confirmationDeleteModal" id="confirmation-delete-modal" centered @hidden="hide">
    <div class="d-flex justify-content-center titleHeader">
      <slot name="title-header">
        <span class="mb-0 text-center">{{ titleHeader }}</span>
      </slot>
    </div>
    <slot name="body">
      <span>この操作は元に戻すことができません。</span>
    </slot>
    <div class="mt-3 d-flex justify-content-center align-items-center" v-if="isShowConfirmDeleteCheckBox">
      <label class="d-flex justify-content-center align-items-center">
        <b-form-checkbox type="checkbox" :value="true" :unchecked-value="false" v-model="isDeleteConfirmationChecked" />
        {{ confirmationDeleteMessage }}
      </label>
    </div>
    <div class="mt-3 d-flex justify-content-center align-items-center" v-if="isShowConfirmRestoreDataCheckBox">
      <label class="d-flex justify-content-center align-items-center">
        <b-form-checkbox type="checkbox" :value="true" :unchecked-value="false" v-model="isRestoreDataConfirmChecked" />
        CSVエクスポートする
      </label>
    </div>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-around">
        <b-button variant="link text-dark text-decoration-none" @click="hide">
          キャンセル
        </b-button>
        <b-button class="accept-button" variant="link text-dark text-decoration-none" @click="submit"
          :disabled="isShowConfirmDeleteCheckBox && !isDeleteConfirmationChecked">
          OK
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    titleHeader: {
      type: String,
      default: '削除してもよろしいですか？'
    },
    isShowConfirmDeleteCheckBox: {
      type: Boolean,
      default: false
    },
    confirmationDeleteMessage: {
      type: String,
      default: '本当に削除してもよろしいでしょうか？'
    },
    isRestoreDataAllowed: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dataEmitted: {},
      isSubmit: false,
      isDeleteConfirmationChecked: false,
      isShowConfirmRestoreDataCheckBox: false,
      isRestoreDataConfirmChecked: true
    }
  },
  watch: {
    isDeleteConfirmationChecked: {
      handler() {
        this.$emit('on-delete-allowed', this.isDeleteConfirmationChecked)
      }
    },
    isRestoreDataConfirmChecked: {
      handler() {
        this.$emit('on-restore-data-allowed', this.isRestoreDataConfirmChecked)
      }
    }
  },
  methods: {
    show(data) {
      this.dataEmitted = data
      this.isSubmit = false
      this.isDeleteConfirmationChecked = false
      this.isShowConfirmRestoreDataCheckBox = this.isRestoreDataAllowed && data.modeDelete === 'delete-all'
      this.isRestoreDataConfirmChecked = this.isShowConfirmRestoreDataCheckBox
      this.$refs.confirmationDeleteModal.show()
    },
    hide() {
      if (!this.isSubmit) {
        this.$emit('on-delete', this.dataEmitted, this.isSubmit, 'confirmation-delete-modal')
      }
    },
    submit() {
      this.isSubmit = true
      this.$emit('on-delete', this.dataEmitted, this.isSubmit, 'confirmation-delete-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/custom-components/DeleteModalComponent.vue